import React, { useState, useEffect, useCallback } from "react";
// import HeaderDashboard from "../../part/header.dashaboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import { useParams } from "react-router-dom";
import Image1 from "../../image/tope.jpg"
// import axios from "axios";
import DescribeBody from "../../part/description.body";
import AddVideo from "../../part/addvideo";
import AddProcedure from "../../part/addprocedure";
import AddDocument from "../../part/add.document";
import DescribeCourse from "../../part/course_description";
import RelatedVideo from "../../part/related_videos";
import CourseVideo from "../../part/course_video";
import DocumentCourse from "../../part/course_description_document";
import IncludeCourse from "../../part/course_include";
import CourseProcedure from "../../part/course.procedure";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import TutorAssignmentCourse from "../../part/course_assignment";
import TutorCourseReview from "../../part/course.review";
import TutorExamSection from "../../part/exam_list";
import AddExam from "../../part/add.exam";
import TutorAddReview from "../../part/add.review";
// import AddCourseUploader from "../../part/addcourseupload";
// import FloatingContact from "../../part/floating.contact";



const TutorCourseDescription = () => {

    const getInitialMenuCoverWidth = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    };
    const [documentsNeedRefresh, setDocumentsNeedRefresh] = useState(false);
    const [menuCoverWidth, setMenuCoverWidth] = useState(getInitialMenuCoverWidth());
    const { course_id } = useParams();
    // const [isContactVisible, setIsContactVisible] = useState(false)
    

    // const [courses, setCourses] = useState([]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const accessToken = localStorage.getItem("accessToken");

    //         try {
    //             const response = await axios.get("https://geoacademy.pythonanywhere.com/api/tutor/courses/", {
    //                 headers: {
    //                     Authorization: `Bearer ${accessToken}`,
    //                 },
    //             });
    //             setCourses(response.data);
    //         } catch (error) {
    //             console.error("Error fetching courses:", error);
    //         }
    //     };
    //     fetchData();
    // }, [course_id]);

// refresh the api in other page 

const handleDocumentAdded = () => {
    setDocumentsNeedRefresh(true);
  };

  const handleRefreshDone = () => {
    setDocumentsNeedRefresh(false);
  };


// it end here 

    const handleResize = useCallback(() => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            setMenuCoverWidth(menuCover.offsetWidth);
        }
    }, []);



    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);

        };
    }, [handleResize]);


    // the add button control



    // const handleContactDisplay = () => {
    //     setIsContactVisible(prevState => !prevState); // Correct toggle
    // };

    return (
        <div className="dashboard ">
            <DashSearchHeader onResize={handleResize} />
            <TutorDashMenu />
            <div className="dash_body tutor" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }}>

                <DescribeBody course_id = {course_id} />

                <div className="description_information">



                    <CourseVideo course_id = {course_id} shouldRefresh={documentsNeedRefresh} onRefreshDone={handleRefreshDone}/>


                    <IncludeCourse course_id = {course_id}/>


                   
                    <CourseProcedure course_id = {course_id} shouldRefresh={documentsNeedRefresh} onRefreshDone={handleRefreshDone}/>


                    <DescribeCourse course_id = {course_id}/>


                    <RelatedVideo course_id = {course_id}/>



                    {/* <section className="analysis_covered">
                        <h3>Analysis covered in this course</h3>
                        <button>Python</button><button>land use land cover</button><button>elevation</button>
                    </section> */}



                    <DocumentCourse course_id = {course_id} shouldRefresh={documentsNeedRefresh} onRefreshDone={handleRefreshDone}/>




                    <section className="course_instructor">
                        <h3>Instructor</h3>
                        <div className="image"> <img src={Image1} alt="CEO" /></div>
                        <div className="about">
                            <h4>Mr Tope <br /><span>CEO at Geoinfotech</span> </h4>
                        </div>
                    </section>
                    <TutorCourseReview course_id = {course_id} />
                    <TutorAssignmentCourse course_id = {course_id} />
                    <TutorExamSection course_id = {course_id} shouldRefresh={documentsNeedRefresh} onRefreshDone={handleRefreshDone}/>
                </div>
                <FooterDashboard 
                // handleContactDisplay={handleContactDisplay} 

                />
                {/* <div className="dashboardfloatcontact" style={{ display: isContactVisible ? 'inline' : 'none' }}><FloatingContact /></div> */}
                <AddVideo course_id = {course_id} onDocumentSubmit={handleDocumentAdded}/>
                <AddProcedure course_id = {course_id} onDocumentSubmit={handleDocumentAdded}/>
                <AddDocument course_id = {course_id} onDocumentSubmit={handleDocumentAdded}/>
                <AddExam course_id = {course_id} onDocumentSubmit={handleDocumentAdded}/>
                <TutorAddReview course_id = {course_id} onDocumentSubmit={handleDocumentAdded}/>
                <Policy/>
                
            </div>

        </div>
    );
};

export default TutorCourseDescription;